var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "service__unselected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-prestataires-(black)",
    transform: "translate(0.000000, -1.000000)",
    fill: "#172134",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "service__unselected",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,18 L22,18 L22,20 L0,20 L0,18 L2,18 L2,1 C2,0.734784 2.10536,0.48043 2.29289,0.292893 C2.48043,0.105357 2.73478,0 3,0 L19,0 C19.2652,0 19.5196,0.105357 19.7071,0.292893 C19.8946,0.48043 20,0.734784 20,1 L20,18 Z M18,18 L18,2 L4,2 L4,18 L18,18 Z M7,9 L10,9 L10,11 L7,11 L7,9 Z M7,5 L10,5 L10,7 L7,7 L7,5 Z M7,13 L10,13 L10,15 L7,15 L7,13 Z M12,13 L15,13 L15,15 L12,15 L12,13 Z M12,9 L15,9 L15,11 L12,11 L12,9 Z M12,5 L15,5 L15,7 L12,7 L12,5 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceUnselected);
export default __webpack_public_path__ + "static/media/service_unselected.6096167aaa24f891feeff5c95059c26e.svg";
export { ForwardRef as ReactComponent };